import { DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  InvoiceExtra,
  InvoiceExtraType,
  InvoiceExtraTypeMap,
  saveInvoiceExtra,
} from 'wisestep-api';
import { Button, ControlledTextInput, WsRadioGroup, WsSelect } from 'wisestep-base';

import WsCheckBox from '../../../components/WsCheckBox/WsCheckBox';
import { failed, success } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { FormProps } from '../../clientsSettings/components/FormProps';

const invoiceExtraFormDefaults = {
  percentage: false,
  absolute: false,
  appliedAfterTax: false,
};

const InvoiceExtraForm = ({ onSave, onClose, defaultValues }: FormProps<InvoiceExtra>) => {
  const form = useForm({ defaultValues: { ...invoiceExtraFormDefaults, ...defaultValues } });
  const setNotification = useNotificationStore((state) => state.setNotification);
  const { watch } = form;
  const { behavior } = watch();

  const onSubmit = async (data) => {
    try {
      await saveInvoiceExtra(data);
      setNotification(success('Invoice extra has been saved successfully !!'));
      onSave();
    } catch {
      setNotification(failed('Something went wrong, Please try again !!'));
    }
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <DialogTitle>Add/Edit Invoice Extra</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <ControlledTextInput
                name="name"
                labelText="Extra Name"
                inputProps={{}}
                size="small"
                required
              />
            </Grid>
            <Grid item xs={6}>
              <WsSelect required label="Calculation" name="type" selectArray={invoiceExtraTypes} />
            </Grid>
            <Grid item xs={12}>
              <WsRadioGroup
                name="behavior"
                selectArray={[
                  {
                    label: 'Description',
                    value: 'DESCRIPTION',
                  },
                  {
                    label: 'Computation',
                    value: 'COMPUTATION',
                  },
                ]}
              />
            </Grid>
            {behavior !== 'DESCRIPTION' && (
              <>
                <Grid item xs={6}>
                  <WsCheckBox name="percentage" label="Percentage" />
                </Grid>
                <Grid item xs={6}>
                  <WsCheckBox name="absolute" label="Amount" />
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit">Save</Button>
        </DialogActions>
      </form>
    </FormProvider>
  );
};

export default InvoiceExtraForm;

const invoiceExtraTypes = [
  {
    label: InvoiceExtraTypeMap[InvoiceExtraType.ADDITIVE],
    value: InvoiceExtraType.ADDITIVE,
  },
  {
    label: InvoiceExtraTypeMap[InvoiceExtraType.SUBTRACTIVE],
    value: InvoiceExtraType.SUBTRACTIVE,
  },
];
